import Vue from 'vue';
import dayjs from '../../plugins/dayjs';

Vue.mixin({
  methods: {
    dateFormatting(date) {
      if (!date) return null;

      return dayjs(date).format('D.M.YYYY');
    },
    dateFormattingHours(date) {
      if (!date) return null;

      return dayjs(date).format('D.M.YYYY H:mm');
    },
    dateFormattingSpecial(date, format) {
      if (!date) return null;

      return dayjs(date).format(format);
    },
  },
});
